type IconSize = {
    width: number;
    height: number;
};

type ZoomAwareScreenIconSizeParams = {
    screenIconSize: IconSize;
    referenceZoom: number;
    currentZoom: number;
    minVisiblePx: number;
};

export const calculateZoomAwareScreenIconSize = ({
    screenIconSize,
    referenceZoom,
    currentZoom,
    minVisiblePx,
}: ZoomAwareScreenIconSizeParams): IconSize => {
    const zoomScale = Math.pow(2, currentZoom - referenceZoom);
    const scaledWidth = screenIconSize.width * zoomScale;
    const scaledHeight = screenIconSize.height * zoomScale;
    const minScaledDimension = Math.min(scaledWidth, scaledHeight);
    if (minScaledDimension >= minVisiblePx) {
        return {
            width: Math.round(scaledWidth),
            height: Math.round(scaledHeight),
        };
    }
    const minScaleFactor = minVisiblePx / minScaledDimension;
    return {
        width: Math.round(scaledWidth * minScaleFactor),
        height: Math.round(scaledHeight * minScaleFactor),
    };
};
